"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var ElongOrderModule = /** @class */ (function (_super) {
    __extends(ElongOrderModule, _super);
    function ElongOrderModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * 获取艺龙订单列表
   * @param end_date	结束时间 string @mock=2018-11-11
   * @param mobile 手机号 string
   * @param name 名称 string
   * @param order_id 订单号 string
   * @param out_order_id 外部订单号--艺龙 string
   * @param page_num 当前页 string
   * @param page_size 页码 string
   * @param pay_status 支付状态，0-未支付，1--已支付,2--待退款，3--已退款，4--支付失败 number
   * @param start_date 开始时间 string
   * @param status 订单状态，0-待支付，1-待入住，2-已完成 3-已取消 number
   */
    ElongOrderModule.prototype.queryOrderList = function (params, token) {
        return this.gatewayClient.queryElongOrderList(params, token);
    };
    /**
   * 导出艺龙订单列表
   * @param end_date	结束时间 string @mock=2018-11-11
   * @param mobile 手机号 string
   * @param name 名称 string
   * @param order_id 订单号 string
   * @param out_order_id 外部订单号--艺龙 string
   * @param page_num 当前页 string
   * @param page_size 页码 string
   * @param pay_status 支付状态，0-未支付，1--已支付,2--待退款，3--已退款，4--支付失败 number
   * @param start_date 开始时间 string
   * @param status 订单状态，0-待支付，1-待入住，2-已完成 3-已取消 number
   */
    ElongOrderModule.prototype.downloadList = function (params, token) {
        return this.gatewayClient.exportList(params, token);
    };
    /**
   * elongOrderDetail 订单详情
   * @param orderId
   * @param token
   */
    ElongOrderModule.prototype.elongOrderDetail = function (orderId, token) {
        return this.gatewayClient.getElongOrderDetail(orderId, token);
    };
    /**
   * orderContral 订单操作日志
   * @param orderId
   * @param token
   */
    ElongOrderModule.prototype.elongOrderContral = function (orderId, token) {
        return this.gatewayClient.getElongOrderContral(orderId, token);
    };
    /**
   * orderCancel 取消订单
   * @param operator_id 操作人（必填）string	@mock=1111
   * @param operator_name 操作人名称（必填）string @mock=测试
   * @param order_id	订单号（必填）	string	@mock=568213647564013568
   * @param reason	取消原因（必填）	string	@mock=test
   */
    ElongOrderModule.prototype.elongOrderCancel = function (params, token) {
        return this.gatewayClient.getElongOrderCancel(params, token);
    };
    /**
   * queryTransactionList 获取查询交易列表
   * @param end_date	结束时间 string @mock=2018-11-11
   * @param order_id  订单号 string
   * @param out_order_id 外部订单号--艺龙 string
   * @param page_num 当前页 string
   * @param page_size 页码 string
   * @param pay_status 支付状态，0-未支付，1--已支付,2--待退款，3--已退款，4--支付失败 number
   * @param source_type 来源类型，微信：0；IOS：2；安卓：3；小程序：14  string
   * @param start_date 开始时间 string
   * @param trade_type 交易类型，1--支付，2--退款 string
   *
   */
    ElongOrderModule.prototype.queryTransactionList = function (params, token) {
        return this.gatewayClient.queryTransactionList(params, token);
    };
    return ElongOrderModule;
}(gateway_module_1.GatewayModule));
exports.ElongOrderModule = ElongOrderModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9lbG9uZy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFFQSxvREFBa0Q7QUFFbEQ7SUFBc0Msb0NBQWE7SUFBbkQ7O0lBaUlBLENBQUM7SUFoSUM7Ozs7Ozs7Ozs7OztLQVlDO0lBQ00seUNBQWMsR0FBckIsVUFDRSxNQVdDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLG1CQUFtQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUMvRCxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7OztLQVlDO0lBQ00sdUNBQVksR0FBbkIsVUFDRSxNQVdDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLFVBQVUsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDdEQsQ0FBQztJQUVEOzs7O0tBSUM7SUFDTSwyQ0FBZ0IsR0FBdkIsVUFBd0IsT0FBZSxFQUFFLEtBQWE7UUFDcEQsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsbUJBQW1CLENBQUMsT0FBTyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2hFLENBQUM7SUFFRDs7OztLQUlDO0lBQ00sNENBQWlCLEdBQXhCLFVBQXlCLE9BQWUsRUFBRSxLQUFhO1FBQ3JELE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLG9CQUFvQixDQUFDLE9BQU8sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNqRSxDQUFDO0lBRUQ7Ozs7OztLQU1DO0lBQ00sMkNBQWdCLEdBQXZCLFVBQ0UsTUFLQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxtQkFBbUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDL0QsQ0FBQztJQUVEOzs7Ozs7Ozs7Ozs7S0FZQztJQUNNLCtDQUFvQixHQUEzQixVQUNFLE1BVUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsb0JBQW9CLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2hFLENBQUM7SUFDSCx1QkFBQztBQUFELENBQUMsQUFqSUQsQ0FBc0MsOEJBQWEsR0FpSWxEO0FBaklZLDRDQUFnQiJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/elong/index.js
// module id = 224
// module chunks = 44